import React from 'react';

const Disclaimer: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Disclaimer
        </h1>
        <div className="prose max-w-none">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">No Legal Advice</h2>
          <p className="text-gray-600 mb-6">
            The Divorce Property Calculator is an informational tool only. It does not provide legal advice, and no attorney‑client relationship is formed by using the Site. Laws vary significantly by jurisdiction, and the outcome of any divorce proceeding depends on many factors unique to each case, including judicial discretion, specific facts, and any agreements between the parties.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mb-3">Accuracy Not Guaranteed</h2>
          <p className="text-gray-600 mb-6">
            While we strive to reflect the general legal principles of the states we cover, we cannot guarantee that the calculations are accurate for your particular situation. Court decisions, changes in legislation, or individual case circumstances may lead to different results.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mb-3">Use at Your Own Risk</h2>
          <p className="text-gray-600 mb-6">
            Your reliance on any information or output from the Site is solely at your own risk. We strongly recommend that you seek independent legal advice from a qualified attorney licensed to practice in your state before making any decisions related to divorce, property division, or support.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mb-3">No Warranty</h2>
          <p className="text-gray-600 mb-4">
            The Site is provided “as is" without any warranties, express or implied.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
